var $0d52933d05ed8f06$exports = {};
$0d52933d05ed8f06$exports = {
    "backButton": (args)=>`Terug naar ${args.prevMenuButton}`,
    "moreActions": `Meer handelingen`,
    "unavailable": `Niet beschikbaar, uitvouwen voor meer informatie`
};


export {$0d52933d05ed8f06$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
